module.exports = __webpack_public_path__ + "img/logo2-1.7731b8f3.png";